export default {
    en: {
        feedback_title:"Optimization Complete",
        feedback_desc1:"Help us improve with your feedback",
        feedback_desc2:"(Collected data will be used solely for service improvement purposes.)",
        
        sec_label:"s",

        polygon_reduce_label:"Polygons",
        vertex_reduce_label:"Vertices",
        filesize_reduce_label:"File Size",
        processing_time_label1:"Processing",
        processing_time_label2:"Time",
        reduce_label:"Reduction",

        rating_question:"How would you rate this optimization?",

        quality_question:"How well was the shape preserved?",
        quality_answer1:"Excellent",
        quality_answer2:"Good",
        quality_answer3:"Fair",
        quality_answer4:"Poor",
        
        speed_question:"How was the processing speed?",
        speed_answer1:"Very Fast",
        speed_answer2:"Fast",
        speed_answer3:"Fair",
        speed_answer4:"Slow",

        field_question:"What's your primary use case?",
        field_answer1:"Automotive",
        field_answer2:"Manufacturing",
        field_answer3:"Architecture",
        field_answer4:"Gaming",
        field_answer5:"Other",

        additional_question:"Any additional feedback?",
        additional_desc:"Share suggestions, feature requests, or issues you encountered.",

        send_feedback:"Submit & Download",
        go_to_back:"Back",
    },
    ko: {
        feedback_title:"최적화 완료",
        feedback_desc1:"더 나은 서비스를 위해 소중한 피드백을 부탁드립니다.",
        feedback_desc2:"(수집된 데이터는 서비스 개선 목적으로만 사용됩니다.)",
        
        sec_label:"초",

        
        polygon_reduce_label:"폴리곤 감소",
        vertex_reduce_label:"버텍스 감소",
        filesize_reduce_label:"파일크기 감소",
        processing_time_label1:"처리 시간",
        processing_time_label2:" ",
        reduce_label:" ",
        rating_question:"이 최적화 결과는 어떠셨나요?",

        quality_question:"형상 보존 품질은 어떠셨나요?",
        quality_answer1:"매우 좋음",
        quality_answer2:"좋음",
        quality_answer3:"보통",
        quality_answer4:"아쉬움",
        
        speed_question:"처리 속도는 어떠셨나요?",
        speed_answer1:"매우 빠름",
        speed_answer2:"빠름",
        speed_answer3:"보통",
        speed_answer4:"느림",

        field_question:"어떤 분야에서 사용하실 예정인가요?",
        field_answer1:"자동차",
        field_answer2:"제조업",
        field_answer3:"건축",
        field_answer4:"게임",
        field_answer5:"기타",

        additional_question:"추가 의견이 있으시면 자유롭게 작성해주세요.",
        additional_desc:"개선사항, 추가 기능 요청, 사용 중 발견한 문제점 등을 알려주세요.",

        send_feedback:"피드백 제출 및 다운로드",
        go_to_back:"돌아가기",
    },
    ja: {
        feedback_title:"最適化完了",
        feedback_desc1:"より良いサービスのために貴重なフィードバックをお願いいたします。",
        feedback_desc2:"(収集されたデータはサービス改善目的のみに使用されます。)",
        
        sec_label:"秒",

        
        polygon_reduce_label:"頂点削減",
        vertex_reduce_label:"ポリゴン削減",
        filesize_reduce_label:"ファイルサイズ削減",
        processing_time_label1:"処理時間",
        processing_time_label2:" ",
        reduce_label:" ",
        rating_question:"이 최적화 결과는 어떠셨나요?",

        quality_question:"형상 보존 품질은 어떠셨나요?",
        quality_answer1:"매우 좋음",
        quality_answer2:"좋음",
        quality_answer3:"보통",
        quality_answer4:"아쉬움",
        
        speed_question:"처리 속도는 어떠셨나요?",
        speed_answer1:"매우 빠름",
        speed_answer2:"빠름",
        speed_answer3:"보통",
        speed_answer4:"느림",

        field_question:"어떤 분야에서 사용하실 예정인가요?",
        field_answer1:"자동차",
        field_answer2:"제조업",
        field_answer3:"건축",
        field_answer4:"게임",
        field_answer5:"기타",

        additional_question:"추가 의견이 있으시면 자유롭게 작성해주세요.",
        additional_desc:"개선사항, 추가 기능 요청, 사용 중 발견한 문제점 등을 알려주세요.",

        send_feedback:"フィードバック送信してダウンロード",
        go_to_back:"戻る",
    },
};

